import type { RouterOutputs } from '../../lib/trpc';

export type SavingsHistory = RouterOutputs['savings']['history'];
export type SavingsPot = SavingsHistory['pots'][number];
export type SavingsPoint = SavingsHistory['totals'][number];
export type SavingsPeriod = SavingsHistory['periods'][number];

/**
 * Mean net per period over the finished periods (the ongoing one is still
 * filling up), counted from the first period with any movement so the
 * months before saving started don't drag it down.
 */
export function averageNet(points: SavingsPoint[]): number | null {
  const start = points.findIndex((p) => p.deposited > 0 || p.withdrawn > 0);
  if (start === -1) return null;
  const active = points.slice(start);
  const finished = active.slice(0, -1);
  const source = finished.length > 0 ? finished : active;
  if (source.length === 0) return null;
  return Math.round(source.reduce((sum, p) => sum + p.net, 0) / source.length);
}
